function SectionDivider(props) {
    return (
        <div className={`h-1.5 w-20 bg-gray-600 rounded-full ${props.className}
            bg-gradient-to-l from-gradient-start-color to-gradient-end-color`}/>
    );
}

export default SectionDivider;